import { useTranslation } from "react-i18next";
import PrivacyFooter from "../../../widgets/footer/PrivacyFooter";
import PrivacyHeader from "../../../widgets/header/PrivacyHeader";
import { Seo } from "../../../shared/seo/Seo";
import { LegalJsonLd } from "../../../shared/seo/JsonLd";

const ClientAppPrivacy = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === "ru" ? "ru" : "uz";

  return (
    <>
      <Seo path="/client-app/privacy" lang={lang} />
      <LegalJsonLd lang={lang} path="/client-app/privacy" />
      {/* Header and footer sit outside the container so they span the full width, as on the
          business-app legal pages. */}
      <PrivacyHeader />
      <div className="container mx-auto px-4 py-8">
        <main className="mx-auto border-t border-b border-[#E2E8F0] pt-8">
          <h1 className="text-3xl font-bold mb-6">{t('client_privacy.title')}</h1>
          <p className="mb-2">
            <strong>{t('client_privacy.effective_date')}</strong>
          </p>
          <p className="mb-6">
            <strong>{t('client_privacy.last_update')}</strong>
          </p>
          <p className="mb-8">{t('client_privacy.introduction')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_privacy.data_collection.title')}</h2>
          <ul className="list-disc pl-6 mb-8">
            {(t('client_privacy.data_collection.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
              <li key={index} className="mb-2">{item}</li>
            ))}
          </ul>

          <h2 className="text-2xl font-semibold mb-4">{t('client_privacy.data_usage.title')}</h2>
          <ul className="list-disc pl-6 mb-8">
            {(t('client_privacy.data_usage.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
              <li key={index} className="mb-2">{item}</li>
            ))}
          </ul>

          <h2 className="text-2xl font-semibold mb-4">{t('client_privacy.data_protection.title')}</h2>
          <ul className="list-disc pl-6 mb-8">
            {(t('client_privacy.data_protection.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
              <li key={index} className="mb-2">{item}</li>
            ))}
          </ul>

          <h2 className="text-2xl font-semibold mb-4">{t('client_privacy.data_sharing.title')}</h2>
          <p className="mb-8">{t('client_privacy.data_sharing.text')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_privacy.payment_data.title')}</h2>
          <p className="mb-8">{t('client_privacy.payment_data.text')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_privacy.user_rights.title')}</h2>
          <p className="mb-8">{t('client_privacy.user_rights.text')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_privacy.analytics.title')}</h2>
          <p className="mb-8">{t('client_privacy.analytics.text')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_privacy.age_restriction.title')}</h2>
          <p className="mb-8">{t('client_privacy.age_restriction.text')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_privacy.policy_changes.title')}</h2>
          <p className="mb-8">{t('client_privacy.policy_changes.text')}</p>

          <h2 className="text-2xl font-semibold mb-4">{t('client_privacy.contact.title')}</h2>
          <p className="mb-2">{t('client_privacy.contact.email')}</p>
          <p className="mb-2">{t('client_privacy.contact.phone')}</p>
          <p className="mb-8">{t('client_privacy.contact.address')}</p>
        </main>
      </div>
      <PrivacyFooter />
    </>
  );
};

export default ClientAppPrivacy;
